var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "ImageUpload",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-img-upload","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <polygon points="120,17.2 120,137 129,137 129,16.6 175.6,58.8 181.6,52.1 124.4,0.3 71.2,52.2 77.5,58.7"/>
  <path d="M148 94v9h76v115.7l-75.3-58.5L94 205.4l-14.3-12.5L27 232V103h75v-9H18v144.6l-.1.1.1.2V250h215V94h-85zm76 147H29.9l49.4-36.6 14.6 12.7 55-45.5L224 230v11z"/>
  <path d="M44.2 144.3c0 13 10.5 23.5 23.5 23.5s23.5-10.5 23.5-23.5-10.5-23.5-23.5-23.5-23.5 10.6-23.5 23.5zm38 0c0 8-6.5 14.5-14.5 14.5s-14.5-6.5-14.5-14.5 6.5-14.5 14.5-14.5 14.5 6.5 14.5 14.5z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/image-upload.svg